import { useMutation } from 'react-query';

import {
  createRegisterInterest,
  CreateRegisterInterestArgs,
} from '@keaze/web/api/listings/createRegisterInterest';
import {
  RegisterInterestResponse,
  RequestError,
} from '@keaze/web/common/interfaces';

export const useRegisterInterestMutate = () =>
  useMutation<
    RegisterInterestResponse,
    RequestError,
    CreateRegisterInterestArgs
  >((args) => createRegisterInterest(args));
